import { Commit } from 'vuex'
import IMedico from '../../models/IMedico'
import ICustomizacao from '../../models/ICustomizacao'

export const SET_MEDICO = 'SET_MEDICO'
export const RESET_STATE = 'RESET_STATE'
export const SET_CUSTOMIZACAO = 'SET_CUSTOMIZACAO'
export const UPDATE_PERFIL = 'UPDATE_PERFIL'

const getDefaultState = () => {
  return {
    id: 0,
    atendimento_ambulatorial: null,
    nome: true,
    email: '',
    genero: null,
    tipo_atendimento: '',
    encrypted_id: '',
    customizacao: {
      color_theme: '#006bf2',
      url_logo: '/plataforma-limer.png',
    },
  }
}
const state = getDefaultState()

const mutations = {
  [RESET_STATE]: (state: IMedico) => Object.assign(state, getDefaultState()),
  [SET_CUSTOMIZACAO]: (
    state: IMedico,
    { workspace, colorTheme, urlLogo }: { workspace: string; colorTheme: string; urlLogo: string }
  ) => {
    state.customizacao.workspace = workspace
    state.customizacao.color_theme = colorTheme
    state.customizacao.url_logo = urlLogo
  },
  [UPDATE_PERFIL]: (state: IMedico, { nome, email, genero }: Pick<IMedico, 'nome' | 'email' | 'genero'>) => {
    state.nome = nome
    state.email = email
    state.genero = genero ?? null
  },
  [SET_MEDICO]: (
    state: IMedico,
    {
      medico,
      mainCustomizacao,
      customizacoes,
    }: { medico: IMedico; mainCustomizacao: ICustomizacao; customizacoes: ICustomizacao[] }
  ) => {
    state.id = medico.id
    state.atendimento_ambulatorial = medico.atendimento_ambulatorial
    state.nome = medico.nome
    state.email = medico.email
    state.genero = medico.genero ?? null
    state.tipo_atendimento = medico.tipo_atendimento
    state.encrypted_id = medico.encrypted_id
    state.customizacao = mainCustomizacao
    state.customizacoes = customizacoes
  },
}

const getters = {
  medico: (state: IMedico) => state,
}
const actions = {
  resetMedico: ({ commit }: { commit: Commit }) => {
    commit(RESET_STATE)
  },
  setMedico(
    { commit }: { commit: Commit },
    {
      medico,
      mainCustomizacao,
      customizacoes,
    }: { medico: IMedico; mainCustomizacao: ICustomizacao; customizacoes: ICustomizacao[] }
  ) {
    commit(SET_MEDICO, { medico, mainCustomizacao, customizacoes })
  },
  updatePerfil({ commit }: { commit: Commit }, perfil: Pick<IMedico, 'nome' | 'email' | 'genero'>) {
    commit(UPDATE_PERFIL, perfil)
  },
  setCustomizacao({ commit }: { commit: Commit }, customizacao: ICustomizacao) {
    commit(SET_CUSTOMIZACAO, customizacao)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
